import React from 'react';
import PropTypes from 'prop-types';

import FieldMetaTable from './FieldMetaTable';

export default class InstanceFields extends React.Component {
  static propTypes = {
    accordionsOpen: PropTypes.array.isRequired,
    getSelectedFieldsSize: PropTypes.func.isRequired,
    installMeta: PropTypes.object.isRequired,
    setObjectStatusIcon: PropTypes.func.isRequired,
    setObjectStatusMsg: PropTypes.func.isRequired,
    toggleAccordion: PropTypes.func.isRequired,
  };

  handleClickRow = key => () => {
    const { toggleAccordion } = this.props;
    toggleAccordion(key);
  };

  renderObjects = (object, key) => {
    const {
      accordionsOpen,
      getSelectedFieldsSize,
      setObjectStatusIcon,
      setObjectStatusMsg,
    } = this.props;
    const isOpen = accordionsOpen.reduce((l, r) => l || r === key, false);
    const passingFields = getSelectedFieldsSize(object.fieldMetas);
    const totalFields = object.fieldMetas.length;
    const objectStatusIcon = setObjectStatusIcon(object, passingFields, totalFields);
    const objectStatusMsg = setObjectStatusMsg(object, passingFields, totalFields);
    return (
      <div key={key} className="card card-block no-padding">
        <div className="panel panel-default" key={key}>
          <div className="panel-heading" role="tab" id={key}>
            <div className="panel-title">
              <div
                data-toggle="collapse"
                data-parent="#accordion"
                onClick={this.handleClickRow(key)}
                role="button"
                tabIndex={0}
                aria-expanded={isOpen}
                aria-controls={key}
                className={isOpen ? 'collapsed single-info panel-active' : 'collapsed single-info'}
              >
                <div className="row">
                  <div className="col-xs-3">
                    <strong>{object.name} </strong>
                  </div>
                  <div className="col-xs-3">
                    <strong>Fields Passing: </strong>
                    {passingFields}/{totalFields}
                  </div>
                  <div className="col-xs-6">
                    <span className="pull-right">
                      <i className={`fa fa-${objectStatusIcon}`} />&nbsp;
                      <weak>
                        <i>{objectStatusMsg}</i>
                      </weak>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            id="collapseOne"
            className={isOpen ? 'panel-collapse collapse in' : 'panel-collapse collapse'}
            role="tabpanel"
            aria-labelledby={key}
            aria-expanded={isOpen}
          >
            {isOpen ? this.renderAccount(object) : null}
          </div>
        </div>
      </div>
    );
  };

  renderAccount = object => {
    const { keyField } = object;
    return (
      <div className="card card-block">
        {this.renderKeyFieldData(keyField)}
        <hr />
        <div className="container-secondary">
          <FieldMetaTable fieldMetas={object.fieldMetas} />
        </div>
      </div>
    );
  };

  renderKeyFieldData = keyField => {
    const icon = keyField.status.statusType === 'OK' ? 'check' : 'times';
    const descriptions = keyField.description.split(', ');

    return (
      <div className="row justify-content-center">
        <div className="col-xs-6">
          {descriptions.map(description => {
            const d = description.split(': ');
            return (
              <p key={description}>
                <strong>{`${d[0]}:`} </strong>
                {d[1]}
              </p>
            );
          })}
        </div>
        <div className="col-xs-6">
          <p>
            <strong>API Name: </strong>
            {keyField.name}
          </p>
          <p>
            <strong>Data Type: </strong>
            {keyField.dataType}
          </p>
          <p>
            <strong>Status Type: </strong>
            <i className={`fa fa-${icon}`} />&nbsp;
            {keyField.status.statusType}
          </p>
          <p>
            <strong>Status Detail: </strong>
            {keyField.status.detail}
          </p>
        </div>
      </div>
    );
  };

  render() {
    const { installMeta } = this.props;
    return (
      <div className="container container-home">
        <div className="row">
          <div className="col-sm-12">
            {installMeta.size > 0 ? (
              installMeta.valueSeq().map(this.renderObjects)
            ) : (
              <p>There are no fields currently configured.</p>
            )}
          </div>
        </div>
      </div>
    );
  }
}
